import React from "react";
import { Framework } from "../services/frameworkAdminService";

interface FrameworkPickerProps {
  frameworks: Framework[];
  value: string;
  onChange: (frameworkId: string) => void;
}

const FrameworkPicker: React.FC<FrameworkPickerProps> = ({ frameworks, value, onChange }) => (
  <select className="form-control" value={value} onChange={(e) => onChange(e.target.value)}>
    <option value="">Select a framework…</option>
    {frameworks.map((f) => (
      <option key={f.id} value={f.id}>
        {f.name}
      </option>
    ))}
  </select>
);

export default FrameworkPicker;
